// Progetti reali VERDEA — ogni progetto con foto Prima / Dopo della stessa area.
const PROJECTS = [
  {
    title: "Realizzazione tappeto erboso",
    place: "Milano · Maggiolina",
    prima: "/lavori/prato-prima.jpg",
    dopo: "/lavori/prato-dopo.jpg",
  },
  {
    title: "Rifacimento prato",
    place: "Milano · giardino con palma",
    prima: "/lavori/palma-prima.webp",
    dopo: "/lavori/palma-dopo.webp",
  },
  {
    title: "Rifacimento prato e aiuola",
    place: "Milano · giardino con acero",
    prima: "/lavori/acero-prima.webp",
    dopo: "/lavori/acero-dopo.webp",
  },
];

const DETAILS = [
  { url: "/lavori/posa-prato.jpg", title: "Posa prato in zolle", place: "In cantiere" },
  { url: "/lavori/fornitura-prato.jpg", title: "Fornitura prato in rotoli", place: "In cantiere" },
  { url: "/brand/progettazione.png", title: "Progettazione giardino", place: "Disegno di progetto" },
];

function Photo({ src, title, place, tag, className, testid }) {
  return (
    <figure
      data-testid={testid}
      className={`image-hover-wrap relative bg-[#EFECE5] ${className}`}
    >
      <img src={src} alt={title} className="w-full h-full object-cover" loading="lazy" />
      {tag && (
        <span
          className={`absolute top-4 left-4 z-10 px-3 py-1.5 text-xs tracking-[0.2em] uppercase font-medium ${
            tag === "Dopo" ? "bg-[#1A3628] text-[#FAF9F6]" : "bg-[#FAF9F6]/90 text-[#1A3628]"
          }`}
        >
          {tag}
        </span>
      )}
      <figcaption className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-[#1A3628]/85 via-[#1A3628]/25 to-transparent text-[#FAF9F6]">
        <p className="font-serif-display text-lg md:text-xl tracking-tight">{title}</p>
        {place && (
          <p className="text-xs tracking-[0.2em] uppercase opacity-80 mt-1">{place}</p>
        )}
      </figcaption>
    </figure>
  );
}

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-24 md:py-32 bg-[#FAF9F6]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div className="max-w-2xl">
            <p className="overline mb-6">— Lavori effettuati</p>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#1A3628]">
              Il <span className="font-accent italic font-normal">prima</span> e il{" "}
              <span className="font-accent italic font-normal">dopo</span> dei nostri giardini.
            </h2>
          </div>
          <p className="md:max-w-sm text-sm md:text-base text-[#5C6B62] leading-relaxed">
            Progetti reali realizzati da Alexander a Milano. Ogni lavoro racconta
            un cambiamento — dal terreno spoglio al verde curato.
          </p>
        </div>

        {/* Progetti Prima / Dopo */}
        <div className="space-y-14 md:space-y-16">
          {PROJECTS.map((p, i) => (
            <div key={i} data-testid={`project-${i}`}>
              <div className="flex items-baseline gap-4 mb-4">
                <span className="font-accent italic text-2xl text-[#5C6B62]">
                  0{i + 1}
                </span>
                <div>
                  <h3 className="font-serif-display text-2xl md:text-3xl text-[#1A3628] tracking-tight">
                    {p.title}
                  </h3>
                  <p className="overline mt-1">{p.place}</p>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                <Photo
                  testid={`project-${i}-prima`}
                  src={p.prima}
                  title="Prima dell'intervento"
                  tag="Prima"
                  className="aspect-[4/3]"
                />
                <Photo
                  testid={`project-${i}-dopo`}
                  src={p.dopo}
                  title="Dopo l'intervento"
                  tag="Dopo"
                  className="aspect-[4/3]"
                />
              </div>
            </div>
          ))}
        </div>

        {/* Intervento in evidenza: abbattimento */}
        <div className="mt-16 pt-14 border-t border-[#D5D1C8]">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
            <div className="lg:col-span-5 order-2 lg:order-1">
              <p className="overline mb-4">— Abbattimenti & potature in quota</p>
              <h3 className="font-serif-display text-3xl md:text-4xl text-[#1A3628] tracking-tight leading-tight">
                Interventi in sicurezza, anche in altezza.
              </h3>
              <p className="mt-6 text-base leading-relaxed text-[#5C6B62]">
                Abbattimenti controllati e potature di alberi ad alto fusto con
                piattaforma aerea e dispositivi di sicurezza. Lavoro con
                attrezzatura professionale per operare in totale sicurezza,
                riducendo al minimo l'impatto sull'area circostante e smaltendo
                correttamente il materiale di risulta.
              </p>
            </div>
            <div className="lg:col-span-7 order-1 lg:order-2">
              <Photo
                testid="intervento-abbattimento"
                src="/lavori/abbattimento.jpg"
                title="Abbattimento con piattaforma aerea"
                place="Provincia di Milano"
                className="aspect-[4/3]"
              />
            </div>
          </div>
        </div>

        {/* Dettagli di lavorazione + progettazione */}
        <div className="mt-16 pt-14 border-t border-[#D5D1C8]">
          <p className="overline mb-6">— Dietro le quinte</p>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
            {DETAILS.map((d, i) => (
              <Photo
                key={i}
                testid={`detail-${i}`}
                src={d.url}
                title={d.title}
                place={d.place}
                className={`${i === 2 ? "col-span-2 md:col-span-1" : ""} h-[300px] md:h-[420px]`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
